/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export class SNLog {
    static log(...message) {
        this.onLog(...message);
    }
    static error(error) {
        this.onError(error);
        return error;
    }
}
